import axios from '../helpers/axios'
import { logError } from '../services';
import { IVersion } from '../models';

export const getVersion = async (): Promise<IVersion> => {
  try {
    const { data } = await axios.get('/api/version');
    return data;
  } catch (error) {
    logError(error, 'getVersion failed');
    return Promise.reject(error);
  }
};
